import { type Template } from "@/content/templates/template.types";
import { useLocalizedHref } from "@/libraries/web-framework";

export interface SEOTemplateLinkProps {
    template: Template;
}

export const SEOTemplateLink = ({ template }: SEOTemplateLinkProps) => {
    const learnMoreHref = useLocalizedHref(
        `/software/confluence/templates/${template.urlSlug}`
    );

    return <a href={learnMoreHref}>{template.name}</a>;
};
